'use client';

import { Loader2 } from 'lucide-react';
import OnboardingBrandingPanel from './OnboardingBrandingPanel';

/**
 * Full-screen loading state that reuses the onboarding branding sidebar so the
 * transition from sign-up → (auth resolving / redirect) → onboarding is
 * seamless: the branding panel stays put and only the right-hand content
 * swaps. Used by `ConditionalLayout` (redirecting an onboarding-incomplete user)
 * and by the onboarding `page.tsx` (while the org query resolves).
 */
export default function OnboardingLoadingScreen() {
  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--color-background)' }}>
      <OnboardingBrandingPanel />
      <div className="flex-1 flex items-center justify-center" style={{ transform: 'translateZ(0)' }}>
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: 'var(--color-lime)' }} />
      </div>
    </div>
  );
}
